// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"234399af","453":"68d3893b"}[chunkId] + ".chunk.js";
};